
vouchers.classy.controller({
    name: 'PaymentModalController',
    inject: ['$scope', 'authServiceFactory', 'RestService', 'InformationService', 'PutService', 'PostService', 'SchoolModelService', 'DateService',
        'PurgeService', 'item', 'ModelService', 'VouchersModelService', 'StandardModalCudFactory', '$modalInstance', 'VoucherOrderModelService'],
    init: function()
    {
        this.$.$modalInstance = this.$modalInstance;
        this.$.states = this.InformationService.getStates();
        this.$.provinces = this.InformationService.getProvinces();
        this.$.countries = this.InformationService.getCountries();
        this.$.OtherCountry = '';
        this.$.OtherState = '';
        this.$.item = this.item;
        this.$.putObject = {schoolID: this.SchoolModelService.get()[0].schoolID, CustName: '', CustEmail: '', CustCity: '', CustState: '', CustZip: '', CustCountry: this.SchoolModelService.get()[0]['School_Country'], OrderNum: '',
                        ResponseCode: '', ResponseText: '', Date: 'NOW()', Price: '', Batched: '', Last4: '', item: this.$.item}; 
        this.$.yearOptions = [];    
        for (var j = 0; j < 50; j++) {
            this.$.yearOptions.push({key: this.DateService.getCurrentYear()+j, value: (this.DateService.getCurrentYear()-2000)+j})
        } 
    },
    startSaveProcess: function(scope, instance, form)
    {
        var parent = this;
        instance.options.factor  = .3;
        if (this.$.putObject.CustCountry=="Other") {
            this.$.putObject.CustCountry = this.$.OtherCountry;
            this.$.putObject.CustState = this.$.OtherState;
        }
        return this.VoucherOrderModelService.post(this.SchoolModelService.get()[0].schoolID, this.$.putObject, instance).then(function(result)
             {
                parent.$.$modalInstance.dismiss();
                parent.VoucherOrderModelService.resolveData();
             });
    }
});
